import styled from 'styled-components';

interface IconProps extends React.SVGAttributes<SVGElement> {
  size?: number;
}

const StyledSvg = styled.svg<IconProps>`
  height: ${({ size }) => size}px;
  path {
    stroke: ${({ theme }) => theme.colors.blue};
  }
`;

export const DoubleArrowIcon: React.FC<IconProps> = ({
  color = '#323232',
  size = 24,
  ...props
}) => (
  <StyledSvg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    size={size}
    {...props}
  >
    <path
      d="M8 15L10.8063 12.1937C10.9133 12.0867 10.9133 11.9133 10.8063 11.8063L8 9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 15L15.8495 12.1505C15.9326 12.0674 15.9326 11.9326 15.8495 11.8495L13 9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StyledSvg>
);
